export const ANIMATION_NO_TRANSITION = 'no-transition';
export const ANIMATION_NONE = 'none';
export const ANIMATION_SLIDE_IN = 'slide-in';
export const ANIMATION_SLIDE_OUT = 'slide-out';
